import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=03c02718"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03c02718')) {
      api.createRecord('03c02718', component.options)
    } else {
      api.reload('03c02718', component.options)
    }
    module.hot.accept("./HeaderMenu.vue?vue&type=template&id=03c02718", function () {
      api.rerender('03c02718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/header/type_5/HeaderMenu.vue"
export default component.exports